// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g4-l","buttons":"styles_buttons__342eX"};